<template>
  <base-section :title="$t('title.browse')" :smallTitle="$t('subtitle.browse')" :background="background">
    <template>
      <div class="container">
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <div class="browse-icon">
              <img :src="'/static/icon-brewery.svg'">
              <span class="small-title">
                {{ $t('browse.byBrewery') }}
              </span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="browse-icon">
              <img :src="'/static/icon-style.svg'">
              <span class="small-title">
                {{ $t('browse.byStyle') }}
              </span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="browse-icon">
              <img :src="'/static/icon-region.svg'">
              <span class="small-title">
                {{ $t('browse.byRegion') }}
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row class="button-row" type="flex" justify="center">
          <el-button class="orange-button" @click="onBrowseClick($t('route.browse'), undefined)">
            {{ $t('browse.browse') }}
          </el-button>
        </el-row>
      </div>
    </template>
  </base-section>
</template>

<script>
import BaseSection from '@/components/Section'
export default {
  name: 'Section',
  components: {
    BaseSection
  },
  data () {
    return {
      background: '/static/parallax.jpg'
    }
  },
  mounted () {
  },
  methods: {
    onItemClick (name) {
      this.$router.push({ name })
    },
    onBrowseClick (name, obj) {
      this.$router.push({ path: `/browse` })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.browse-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 100%;
    max-width: 100px;
    padding: 25px 0;
  }

  .small-title {
    color: $white-color;
    font-size: 16px;
    text-align: center;
    font-weight: normal;
    // font-size: $small-title;
  }
}
.button-row {
  padding-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/BrowseSection.vue